module.exports = __webpack_public_path__ + "static/img/top.bded3600.svg";